var _rect, _rect2, _g, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnDns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 580,
    height: 846,
    transform: "translate(-240 -361)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_565_12442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 10.8333H3.33333C2.875 10.8333 2.5 11.2083 2.5 11.6667V16.6667C2.5 17.125 2.875 17.5 3.33333 17.5H16.6667C17.125 17.5 17.5 17.125 17.5 16.6667V11.6667C17.5 11.2083 17.125 10.8333 16.6667 10.8333ZM5.83333 15.8333C4.91667 15.8333 4.16667 15.0833 4.16667 14.1667C4.16667 13.25 4.91667 12.5 5.83333 12.5C6.75 12.5 7.5 13.25 7.5 14.1667C7.5 15.0833 6.75 15.8333 5.83333 15.8333ZM16.6667 2.5H3.33333C2.875 2.5 2.5 2.875 2.5 3.33333V8.33333C2.5 8.79167 2.875 9.16667 3.33333 9.16667H16.6667C17.125 9.16667 17.5 8.79167 17.5 8.33333V3.33333C17.5 2.875 17.125 2.5 16.6667 2.5ZM5.83333 7.5C4.91667 7.5 4.16667 6.75 4.16667 5.83333C4.16667 4.91667 4.91667 4.16667 5.83333 4.16667C6.75 4.16667 7.5 4.91667 7.5 5.83333C7.5 6.75 6.75 7.5 5.83333 7.5Z",
    fill: "#323232"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -139.5,
    y: -145.5,
    width: 379,
    height: 530,
    rx: 4.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_565_12442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDns);
export default __webpack_public_path__ + "static/media/icn_dns.87e2362f291e958430741ffa9137824f.svg";
export { ForwardRef as ReactComponent };